export const BASE_URL = "https://5f21650bdaa42f0016665a5a.mockapi.io/api";
